import { CommentsInput } from 'component/comment';
import { QuestionScreen } from 'structure/question';
import { CLICK, demoFile, extend, story } from 'system/demo';

demoFile('feature/question/multi-answer');

extend(
    'Question Screen',
    'Multi Answer',
    QuestionScreen,
    {
        structureKey: 'question',
        features: ['multi-answer'],
        state: {
            globals: {
                name: 'Are Cats Good?',
            },
            collections: {
                comment: [
                    {
                        key: 'a',
                        text: 'I like cats',
                        from: 'a',
                        time: Date.now(),
                    },
                ],
            },
        },
    },
    [story('Second Answer', [CLICK('comment-input')])],
);
